import { useDelayAssetsGrouped } from "@/shared/selectors/AssetButtonGroup";
import { sortAssetsByArea, toSlug } from "@/shared/utils/assets";
import { useCallback, useEffect, useMemo } from "react";
import { useNavigate, useParams } from "react-router-dom";

type AreaIds = { saws: number; welds: number };

export const useCalendarAssetNavigation = (areaIds: AreaIds) => {
	const { assetName } = useParams<{ assetName?: string }>();
	const navigate = useNavigate();

	const { data: delayAssets } = useDelayAssetsGrouped();

	const assetId = useMemo(() => {
		if (!assetName || !delayAssets) return null;
		const match = delayAssets.find((a) => toSlug(a.AssetName) === assetName);
		return match?.AssetId ?? null;
	}, [assetName, delayAssets]);

	// Auto-redirect to the first asset when none is selected
	useEffect(() => {
		if (assetName || !delayAssets?.length) return;
		const sorted = sortAssetsByArea(delayAssets, areaIds);
		navigate(`/calendar/${toSlug(sorted[0].AssetName)}`, { replace: true });
	}, [assetName, delayAssets, navigate, areaIds]);

	const handleAssetChange = useCallback(
		(slug: string | null) => {
			navigate(slug ? `/calendar/${slug}` : "/calendar");
		},
		[navigate],
	);

	return { assetId, assetName, handleAssetChange };
};
